'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSetAtom } from 'jotai';
import { useLocale } from 'next-intl';
import Script from 'next/script';
import { useRouter } from '@/i18n/navigation';
import { userSessionAtom } from '@/store/atoms';
import { getLanguage } from '@/utility/locale';
import { getUserSession } from '@/utility/loginHelpers';
export type AccountFrameProps = {
  openType: string;
  resetToken?: string;
  subDomain: string;
  context: string;
  onLoginSuccess?: () => void;
};
export const AccountFrame = t0 => {
  const $ = _c(20);
  const {
    openType,
    resetToken,
    subDomain,
    context,
    onLoginSuccess
  } = t0;
  const locale = useLocale();
  const router = useRouter();
  const [hostname, setHostname] = useState();
  const bootStrapped = useRef(false);
  const setUserSession = useSetAtom(userSessionAtom);
  let t1;
  if ($[0] !== context || $[1] !== locale || $[2] !== onLoginSuccess || $[3] !== openType || $[4] !== resetToken || $[5] !== router || $[6] !== setUserSession) {
    t1 = () => {
      if (bootStrapped.current) {
        return;
      }
      const handleLogin = async () => {
        if (onLoginSuccess) {
          onLoginSuccess();
        }
        const session = await getUserSession();
        if (session) {
          setUserSession(session);
        }
      };
      const handleMessage = message => {
        bb11: switch (message) {
          case "LOGIN_SUCCESS":
            {
              handleLogin();
              break bb11;
            }
          case "REGISTER_CUSTOMER_SUCCESS_CONTINUE":
          case "SET_PASSWORD_SUCCESS_CONTINUE":
            {
              router.push("/");
              break bb11;
            }
          case "RENDERING_COMPLETE":
        }
      };
      const loginParams = {
        element: document.getElementById("sprd-accounts"),
        context,
        lang: getLanguage(locale),
        resetToken,
        callback: handleMessage
      };
      bb19: switch (openType) {
        case "forgotPassword":
          {
            window.sprdAccount.renderForgotPassword(loginParams);
            break bb19;
          }
        case "setPassword":
          {
            window.sprdAccount.renderSetPassword(loginParams);
            break bb19;
          }
        case "register":
          {
            window.sprdAccount.renderRegisterCustomer(loginParams);
            break bb19;
          }
        default:
          {
            window.sprdAccount.renderLogin(loginParams);
          }
      }
      bootStrapped.current = true;
    };
    $[0] = context;
    $[1] = locale;
    $[2] = onLoginSuccess;
    $[3] = openType;
    $[4] = resetToken;
    $[5] = router;
    $[6] = setUserSession;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const bootstrapAccountsFrame = t1;
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHostname(window.location.hostname);
    };
    t3 = [];
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[10] !== bootstrapAccountsFrame) {
    t4 = () => {
      if (!!window.sprdAccount) {
        bootstrapAccountsFrame();
      }
    };
    t5 = [bootstrapAccountsFrame];
    $[10] = bootstrapAccountsFrame;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="login mb-8" id="sprd-accounts" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== bootstrapAccountsFrame || $[15] !== hostname || $[16] !== subDomain) {
    t7 = !!hostname && <Script src={"https://" + hostname.replace(subDomain, "accounts") + "/js/client.js"} onLoad={bootstrapAccountsFrame} />;
    $[14] = bootstrapAccountsFrame;
    $[15] = hostname;
    $[16] = subDomain;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};